import { render } from "./WelcomeOnboarding1.vue?vue&type=template&id=7ff61620&scoped=true"
import script from "./WelcomeOnboarding1.vue?vue&type=script&lang=js"
export * from "./WelcomeOnboarding1.vue?vue&type=script&lang=js"

import "./WelcomeOnboarding1.vue?vue&type=style&index=0&id=7ff61620&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff61620"]])

export default __exports__